import BaseRoute from 'seshy/routes/base';
import { service } from '@ember/service';
import { pushPayload } from 'seshy/utils/push-payload';
import { action } from '@ember/object';
import { hash } from 'rsvp';
import { tracked } from '@glimmer/tracking';
import { A } from '@ember/array';
import { later } from '@ember/runloop';
import { task, timeout } from 'ember-concurrency';

export default class AuthenticatedPlayQueueRoute extends BaseRoute {
  @service store;
  @service currentUser;
  @service betaFeatures;

  async model(params) {
    let projects = this.store.query('project', {
      filter: { archived: false },
      page: { size: 10 },
      sort: '-latestVersionUpdatedAt',
      include:
        'owning-team,teams,user,updator,current-project-version,current-project-version.bounces',
    });

    let playlists = this.store.findAll('playlist', {
      page: { size: 10 },
      include: [
        'owning-team',
        'playlist-entries',
        'playlist-entries.project',
        'playlist-entries.project.current-bounce',
        'playlist-entries.project.current-bounce.project',
      ].join(','),
    });

    return hash({
      projects,
      playlists,
    });
  }
}
